<template>
  <i class="icon_wrap"></i>
</template>

<script>
export default {
  name: 'banlance'
};
</script>

<style lang="stylus" scoped>
.icon_wrap
  display inline-block
  width 24px
  height 24px
  background-size 24px 24px
  background-repeat no-repeat
  background-position center
  background-image url('./images/pay_icon_wallet.png')
  background-image image-set(url('./images/pay_icon_wallet.png') 1x, url('./images/pay_icon_wallet@2x.png') 2x)
</style>
